import { render } from "./Send_what’sApp.vue?vue&type=template&id=49383a5f&scoped=true"
import script from "./Send_what’sApp.vue?vue&type=script&lang=js"
export * from "./Send_what’sApp.vue?vue&type=script&lang=js"

import "./Send_what’sApp.vue?vue&type=style&index=0&id=49383a5f&scoped=true&lang=css"

import exportComponent from "/home/lyonjo5/lyon-marketing-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49383a5f"]])

export default __exports__